import actions from "./actions"

const stateDefault = {
  documents: [],
  document: {}
};
export default function clientDocumentReducers(state = stateDefault, action: { type: string; payload: any; }): any {
    switch (action.type){
        case actions.SET_DOCUMENTS:
            return {...state, documents: action.payload};
        case actions.SET_DOCUMENT:
            return {...state, document: action.payload};
        case actions.SET_INITIAL_DOCUMENTS:
            return stateDefault
        default:
            return state
    }
}
